export const getStateSliceFor = ({ state, reducerKey }) => {
  return state[reducerKey]
}
